
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 57.7 57.8"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"57.7","height":"57.83","rx":"4.4","fill":"#2867b2"}}),_c('circle',{attrs:{"cx":"12.6","cy":"13.1","r":"5","fill":"#fff"}}),_c('path',{attrs:{"fill":"#fff","d":"M8.3 21.8h8.6v27.83H8.3zM39.8 20.9a9 9 0 00-6 2c-.9.7-1.9 1.9-2.1 2v-3.1h-8.5v27.8h8.5V34.3a5.6 5.6 0 012.8-5.2 4 4 0 012.3-.4 4.8 4.8 0 014.3 4.5v16.4H50v-20c-.2-4.8-3.4-8.7-10.2-8.7z"}})])
          )
        }
      }
    